export default __webpack_public_path__ + "static/media/PurposeImagePoint.673758dc.png";